import React from 'react';
import PropTypes from 'prop-types';
import { buildPublicAssetURL, buildCompanyAssetURL } from '../../../../utils/assetUtils';
import { formatBytes } from '../../../../utils/StringUtils';
import { ApplicationContext } from '../../../../ApplicationContext';

/**
 *
 */
export default class OfferAttachmentRow extends React.Component {
	/**
	 *
	 * @param props
	 */
	// eslint-disable-next-line no-useless-constructor
	constructor(props) {
		super(props);
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const { fileAsset, company } = this.props;
		const { applicationStore } = this.context;
		const uuid = applicationStore.currentRouteParams.uuid;
		const filePreview = uuid
			? buildPublicAssetURL(uuid, fileAsset.uuid)
			: buildCompanyAssetURL(company.id, fileAsset.uuid);

		return (
			<div className="offer-attachment-row grid border--top">
				<a
					className="offer-attachment-row__description"
					href={filePreview}
					target="_blank"
					rel="noreferrer">
					{this.props.fileAsset.filename}
				</a>
				<span className="offer-attachment-row__size font--meta">
					{formatBytes(this.props.fileAsset.sizeInBytes)}
				</span>
			</div>
		);
	}
}

OfferAttachmentRow.contextType = ApplicationContext;

OfferAttachmentRow.propTypes = {
	company: PropTypes.object.isRequired,
	fileAsset: PropTypes.object.isRequired
};
